import Div1 from './Div1';
import Div2 from './Div2';
import Div3 from './Div3';
import Div4 from './Div4';

export const roadmapSVGs = {
    Div1,
    Div2,
    Div3,
    Div4,
};
